import { FormControlLabel, Switch } from '@mui/material'
import { useContext } from 'react'

import { AppSettingsContext, AuthenticationContext, PlayMapSettings } from '../../../Contexts'

interface Props {
  admin?: boolean
  defaultValue?: boolean
  dev?: boolean
  field: string
  label: string
  onChange?: (playMapSettings: PlayMapSettings) => void
}

const Setting: React.FC<Props> = (props) => {
  const { label, field, admin, dev, defaultValue = false, onChange } = props
  const { authEntity } = useContext(AuthenticationContext)
  const { developerMode } = useContext(AppSettingsContext)
  const { playMapSettings, updatePlayMapSettings } = useContext(AppSettingsContext)

  if (admin && !authEntity?.admin) {
    return null
  }

  if (dev && !developerMode) {
    return null
  }

  const onLocalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSettings = { ...playMapSettings, [field]: event.target.checked }
    updatePlayMapSettings?.(newSettings)
    onChange?.(newSettings)
  }

  return <FormControlLabel label={label} control={<Switch checked={playMapSettings?.[field] ?? defaultValue} onChange={onLocalChange} />} />
}

export default Setting
